import * as Yup from 'yup';

import { Strings } from '@app/constants';

// ---------------addLeaveSchema-------------
export const addLeaveSchema = Yup.object()
  .shape({
    reason: Yup.string()
      .trim()
      .required(Strings.validation.fieldRequired(Strings.field.reason))
      .test('is-not-empty', 'Reason cannot be empty', (value) => value.trim().length > 0),
    leaveType: Yup.string().required(Strings.validation.selectRequired(Strings.field.type)),
    from: Yup.string().required(Strings.validation.fieldRequired(Strings.education.from)),
    to: Yup.string().required(Strings.validation.fieldRequired(Strings.education.to)),
    attachment: Yup.string(),
  })
  .required();
export const updateLeaveStatusSchema = Yup.object()
  .shape({
    reason: Yup.string()
      .trim()
      .required(Strings.validation.fieldRequired(Strings.field.reason))
      .test('is-not-empty', 'Reason cannot be empty', (value) => value.trim().length > 0),
  })
  .required();
export const addExistingLeaveSchema = Yup.object()
  .shape({
    reason: Yup.string()
      .trim()
      .required(Strings.validation.fieldRequired(Strings.field.reason))
      .test('is-not-empty', 'Reason cannot be empty', (value) => value.trim().length > 0),
    leaveType: Yup.string().required(Strings.validation.pleaseSelect(Strings.field.type)),
    from: Yup.string().required(Strings.validation.pleaseSelect(Strings.education.from)),
    to: Yup.string().required(Strings.validation.pleaseSelect(Strings.education.to)),
    name: Yup.number().required(Strings.validation.pleaseSelect(Strings.field.name)),
    approvedBy: Yup.number().required(Strings.validation.pleaseSelect(Strings.field.approvedBy)),
  })
  .required();
